import React, {useEffect, useState} from 'react';
import copy from "copy-to-clipboard";
import Cookie from 'js-cookie';
import {useNavigate} from "react-router-dom";


import {
    Button,
    Card,
    Cascader,
    Checkbox,
    Divider,
    Flex,
    Form,
    FormInstance,
    Input,
    Layout,
    message, Modal, Radio,
    Select,
    SelectProps, Tree
} from "antd";
import Cookies from "js-cookie";
import DirectoryTree from 'antd/es/tree/DirectoryTree';
import dayjs from "dayjs";


let ooon = '';
let returnedData = '';


const Admin_chatmagin = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const date_time = dayjs().unix();

    document.title='话术面板';

    const cookiecheck = () => {


        if (Cookie.get('userToken_chattool') !== null) {


        } else {

            navigate('/login?return_url=/admin/chatmagin');

        }


    }


    document.title = '后台界面 ';
    cookiecheck();


    const Ddata = [
        {
            "data": [
                {
                    "id": 1,
                    "label": "Node 1",
                    "children": [
                        {
                            "id": 2,
                            "label": "Node 1-1",
                            "children": [
                                {
                                    "id": 3,
                                    "label": "Node 1-1-1"
                                }
                            ]
                        },
                        {
                            "id": 4,
                            "label": "Node 1-2"
                        }
                    ]
                },
                {
                    "id": 5,
                    "label": "Node 2"
                }
            ]
        }
    ]


    useEffect(() => {


        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部

        setfetch_tabname_select_log({message: 'click', value: '', time: date_time})

    //    setfetch_tabname_select_info({value1: e1, value2: '', value3: '', time: date_time})

        setButton_onclick_d('11');
       // setref_tab_info_select_log({message: 'd', value: '1', time: date_time})

    }, [])


    const [treedata_va, Settreedata_va] = useState([{}])
    const [treedata_va_tabname, Settreedata_va_tabname] = useState({
        "message": 2000,
        "value": "更新成功",
        "info": [
            {
                "uuid": "8a4719c9-3e19-4cd5-8346-f67e2edce378",
                "title_name": "ROOT XP框架",
                "parent_uuid": "0",
                "colordm": "0xffe66f",
                "created": "2023/11/16 17:21",
                "children": []
            },

        ]
    })



/*

    const [web_tab_name, setWeb_tab_name] = useState([{
        id: 1,
        uuid: '',
        tabname: "问候语",
        color: null,
        tab_state: 1,
        created: "2023/11/16 17:21",
        modified: null,
        deleted: null,
        tabname_reserve_1: null,
        tabname_reserve_2: null,
        tabname_account_key: "956C783F82CB661EA14D12A47A4CE76B6FD7A061737E1D5B9CA2E43C0E03412B245B4E0E7ABA9B97AF35CAD8B74767FB73ACF2D54CA514D039DCAD47BF2DC3CF"
    }])


    const web_tab_formData = new FormData();
    web_tab_formData.append('tab_state', '1');
    web_tab_formData.append('userToken', String(Cookie.get('userToken_chattool')));


    const [ref_tab_info_select_log, setref_tab_info_select_log] = useState({message: '', value: '', time: 0})


    useEffect(() => {
        // 假设fetchTreeData是从服务器获取树形结构数据的异步函数
        const FetchTreeData = async () => {
            const response = await fetch('https://api.chatv2.leytcn.com/messages/postData_table.php', {
                method: 'POST',
                //headers:{'Content-Type': 'application/json'},
                body: web_tab_formData
            });

            const data = await response.json();


            setWeb_tab_name(data);


            console.log({ded: data[0].tabname, all: data})
            setButton_onclick_d('1');

            set_dclick_button({parent_uuid: data[0].uuid, user_access: '', Tabname: data[0].tabname})

            settab_button_info({uuid: data[0].uuid, tabname: data[0].tabname, time: date_time})

        } // 调用函数

        if (Cookie.get('userToken_chattool') === undefined) {

            navigate('/login?return_url=/admin/chatmagin');

        } else {


        }


        if (ref_tab_info_select_log.message !== '') {


            FetchTreeData();
            setref_tab_info_select_log({message: '', value: '', time: 0})
        }


    }, [ref_tab_info_select_log])*/


    const [check_data_array, setcheck_data_array] = useState([]);

    const [user_cookie, setUser_cookie] = useState('');
    const [parent_id, setParent_id] = useState('');

    const [user_access, setUser_access] = useState('');

    const [tabname, SetTabname] = useState('');


    const [button_onclick_d, setButton_onclick_d] = useState('');


    const [tab_button_info, settab_button_info] = useState({uuid: '', tabname: '', time: 0})

    const [jjaf, setdata] = (useState(null));

    const [dclick_button, set_dclick_button] = useState({parent_uuid: '', user_access: '', Tabname: ''})
    const Ddclick_button = (value1: any, value2: any) => {

        const User_cookie = String(Cookie.get('userToken_chattool'));
        setUser_cookie(User_cookie);
        console.log(User_cookie)


        console.log({value1:value1,value2:value2})


        setUser_access(User_cookie);
        setParent_id(value1)
        SetTabname(value2);


        set_dclick_button({parent_uuid: value1, user_access: '', Tabname: value2})

        setButton_onclick_d(value2);

        settab_button_info({uuid: value1, tabname: value2, time: date_time})
        settreeonselectm_info({select_value: '', title: '', status: '', time: 0})

        settreeonselectm_info_sub({select_value_sub: '', status: '',title:'', time: 0})
    }

    const formData_tabname = new FormData();

    formData_tabname.append('parent_uuid', dclick_button.parent_uuid)
    formData_tabname.append('userToken', String(Cookies.get('userToken_chattool')));

    formData_tabname.append('tabname', dclick_button.Tabname);


    useEffect(() => {

        const sub1_txt = async () => {


            const post_tab = await fetch('https://api.chatv2.leytcn.com/messages/postData.php', {

                method: 'POST',
                body: formData_tabname

            })

            const return_txt = await post_tab.json();

         Settreedata_va(return_txt.info.map((item1:any)=>({key:item1.uuid,title:item1.title_name,value:item1.title_name,children:item1.children.map((item2:any)=>({key:item2.uuid,title:item2.title_name,value:item2.title_name,isLeaf:item2.isLeaf}))})));
          //  Settreedata_va_tabname(return_txt);
           // Settreedata_va(treedata_va_tabname.info.filter(filter_item=>filter_item.uuid===value1).map((item1:any)=>(item1.children.map((item2:any)=>({key:item2.uuid,title:item2.title_name,value:item2.title_name})))));

        };


        if (button_onclick_d !== '') {

            //console.log(value,':id')
            sub1_txt();
            console.log('post_tree:', jjaf);
            setButton_onclick_d('');
        }


    }, [button_onclick_d]);


    const onExpand = (value: any, e: any) => {


        console.log({value: value, e: e})

    }
    const [sendl_form_item2, setsendl_form_item2] = useState('');
    const [return_sendl_form_item2, setReturn_sendl_form_item2] = useState([{
        title: '',
        label: '',
        download_url: '',
        is_folder: false
    }]);


    useEffect(() => {


        const form_item_data = async () => {

            const form_item_data_await = await fetch('https://api.chatv2.leytcn.com/ChatUI/new_data_show.php', {

                method: 'POST',
                body: JSON.stringify(sendl_form_item2)


            })

            const return_txt = await form_item_data_await.json();

            setReturn_sendl_form_item2(return_txt);


        }


        if (sendl_form_item2 !== '') {

            form_item_data();
        }


    }, [sendl_form_item2]);

    const [showtreeitem, setshowtreeitem] = useState([]);

    const send_form_data = (value: any) => {

        console.log(value);
        setsendl_form_item2(value);


    }

    const [treeonselectm_info, settreeonselectm_info] = useState({select_value: '', title: '', status: '', time: 0})
    const [treeonselectm_info_sub, settreeonselectm_info_sub] = useState({select_value_sub: '',title:'', status: '', time: 0})


    const Treeonselectm = (value: any, e: any) => {


        console.log(e.node.key)
        console.log(e);
        console.log(e.node.pos);


        if (e.node.children === undefined) {
            copy(e.node.title)


            message.success('复制成功');


            settreeonselectm_info_sub({select_value_sub: e.node.title,title:value, status: 'en', time: date_time})
            settreeonselectm_info({select_value: '', title: '', status: '', time: 0})


        } else {

            setshowtreeitem(e.node.pos);
            settreeonselectm_info({select_value: value, title: e.node.title, status: 'en', time: date_time})

            //  settreeonselectm_info({select_value:'',title:'',status:'',time:0})

            settreeonselectm_info_sub({select_value_sub: '', status: '',title:'', time: 0})

        }
        //    alert(e.node.title)
    }





    const [fetch_tabname_select_info, setfetch_tabname_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_tabname_select_log, setfetch_tabname_select_log] = useState({message: '', value: '', time: 0})
    const fetch_tabname = (e1: any) => {

        setfetch_tabname_select_log({message: 'click', value: '', time: date_time})

        setfetch_tabname_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const [return_data_fetch_tabname,setreturn_data_fetch_tabname]=useState({  "message": 2000,
        "value": "更新成功",
        "info": [
            {
                "uuid": "8a4719c9-3e19-4cd5-8346-f67e2edce378",
                "title_name": "ROOT XP框架",
                "parent_uuid": "0",
                "colordm": "0xffe66f",
                "created": "2023/11/16 17:21",
                "children": []
            },

        ]
    })

    const fetch_tabname_body = new FormData();


    fetch_tabname_body.append('id', fetch_tabname_select_info.value1);

    fetch_tabname_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_tabname_body.append('time', String(fetch_tabname_select_info.time));

    fetch_tabname_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/messages/postData_table.php', {


                method: 'POST',
                body: fetch_tabname_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_tabname(return_data);
                    Settreedata_va_tabname(return_data);
                   // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setButton_onclick_d('');
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if(fetch_tabname_select_log.message!==''){

            data_async();
            setfetch_tabname_select_log({message:'',value:'',time:0})
        }
    }, [fetch_tabname_select_log]);




    /*

        const formdata_va = new FormData();

        formdata_va.append('kk', 'k');


        useEffect(() => {

        const sync_data = async () => {


            const ds = await fetch('https://api.chatv2.leytcn.com/ChatUI/data_show.php',
                {
                    method: 'POST', body: formdata_va
                })
        };


        }, []);

    */

    const [click_file_list, setclick_file_list] = useState('');

    const click_card_file_list = (e: any, ed: any) => {


        console.log(e);


        setclick_file_list(e);
    }

    const [click_file_list222, setclick_file_list222] = useState('');
    const [click_card_file_button_count, setclick_card_file_button_count] = useState(0);

    const click_card_file_list222 = (e: any, ed: any) => {


        console.log(e);

        setclick_card_file_button_count(ed);
        setclick_file_list222(e);
    }


    const body_post_click_card = new FormData();
    body_post_click_card.append('path', click_file_list222);

    useEffect(() => {
        const async_data = async () => {


            const await_post_fetch = await fetch('https://api.chatv2.leytcn.com/ChatUI/click_card_message.php', {
                method: 'POST',

                body: body_post_click_card


            })

            const return_await_data = await await_post_fetch.json();


            setReturn_sendl_form_item2(return_await_data);
        }


        setclick_file_list222('');

        if (click_file_list222 !== '') {
            async_data();

        }
    }, [click_file_list222])


    const [add_desder_option_data, setadd_desder_option_data] = useState('');


    const finish_add_dasder_option = (value: any) => {

        console.log(value);
        console.log(casder_change_data)

        setadd_desder_option_data(value.doption);

    }


    //dasdermang
    const [casder_change_data, Setchekbox_change_msg] = useState('');
    const change_cascader = (value: any) => {


        setcheck_data_array(value);
        console.log(value);

        form.setFieldsValue({form_radio_item1: '', form_radio_item2: '', form_radio_item3: ''});

        if (value.length === 2) {

            Setchekbox_change_msg(value);

            console.log('1111')
        }


    }

    const post_dasder_option_body = new FormData();

    post_dasder_option_body.append('dasder_option_id', JSON.stringify(casder_change_data))
    post_dasder_option_body.append('add_message', add_desder_option_data);


    useEffect(() => {
        const data_async = async () => {

            const data_await = await fetch('https://api.chatv2.leytcn.com/ChatUI/add_cascader_option.php', {
                method: "POST",
                body: post_dasder_option_body


            })
            const return_data_await = await data_await.json();


        }
        if (add_desder_option_data !== '') {
            data_async();

        }


    }, [add_desder_option_data]);


    const [tabname_delete_modal_open, settabname_delete_modal_open] = useState(false)

    const [tabname_delete_select_info, settabname_delete_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [tabname_delete_select_log, settabname_delete_select_log] = useState({message: '', value: '', time: 0})
    const tabname_delete = (uuid: any, tabname: any) => {

        settabname_delete_select_log({message: 'click', value: '', time: date_time})

        settabname_delete_modal_open(true);

        settabname_delete_select_info({value1: uuid, value2: '', value3: '', time: date_time})
    }


    const settabname_delete_modal_oncancel = () => {

        settabname_delete_modal_open(false);
    }


    const [tabname_delete_modal_next_button_select_log, settabname_delete_modal_next_button_select_log] = useState({message: '', value: '', time: 0})

    const tabname_delete_modal_next_button = () => {

        let data_time = dayjs().unix();

        settabname_delete_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_tabname_delete, setreturn_data_tabname_delete] = useState({});

    const tabname_delete_body = new FormData();


    tabname_delete_body.append('uuid', tabname_delete_select_info.value1);

    tabname_delete_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabname_delete_body.append('time', String(tabname_delete_modal_next_button_select_log.time));

    tabname_delete_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/tabinfo/delete/delete_tabname.php', {


                method: 'POST',
                body: tabname_delete_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    settabname_delete_modal_open(false)

                    setreturn_data_tabname_delete(return_data);
                    setfetch_tabname_select_log({message:'122',value:'',time:data_time})

                    //   setref_tab_info_select_log({message: '21', value: '', time: data_time})
                    //      setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

            }

        }


        if (tabname_delete_modal_next_button_select_log.message !== '') {

            data_async();
            settabname_delete_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [tabname_delete_modal_next_button_select_log]);


    const dropdownRender = (menus: React.ReactNode) => (
        <div>
            {menus}
            <Divider style={{margin: 0}}/>
            <div style={{padding: 8}}>
                <label>{casder_change_data}</label>
                <Form name={'ot'} onFinish={finish_add_dasder_option}>

                    <Form.Item name={'doption'}>


                        <Input key={casder_change_data}></Input></Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>添加</Button>


                </Form>

            </div>
        </div>
    );

    const truncateText = (text: any, maxLength: any) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...'; // 截断超出部分，并加上省略        }
        }
        return text;
    };

    const renderTreeNodeTitle = (title: any) => {

        console.log(title)

        return truncateText(title, 10); // 限制标题长度0个字    };
    };
    const [click_path_post_value, setclick_path_post_value] = useState('');


    const [return_get_path_address_data, setReturn_get_path_address_data] = useState([]);
    const click_get_web_address = (value: any) => {

        console.log(value);
        setclick_path_post_value(value);

    }


    const [tabname_edit_modal_open, settabname_edit_modal_open] = useState(false)

    const [tabname_edit_select_info, settabname_edit_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [tabname_edit_select_log, settabname_edit_select_log] = useState({message: '', value: '', time: 0})
    const tabname_edit = (uuid: any, tabname: any) => {

        settabname_edit_select_log({message: 'click', value: '', time: date_time})

        settabname_edit_modal_open(true);

        settabname_edit_select_info({value1: uuid, value2: tabname, value3: '', time: date_time})
    }


    const settabname_edit_modal_oncancel = () => {

        settabname_edit_modal_open(false);
    }


    const [tabname_edit_modal_form] = Form.useForm();

    const tabname_edit_modal_initialValues = {}

    const [tabname_edit_modal_onfinish_select_log, settabname_edit_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [tabname_edit_modal_onfinish_select_info, settabname_edit_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const tabname_edit_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        settabname_edit_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        settabname_edit_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_tabname_edit, setreturn_data_tabname_edit] = useState({});

    const tabname_edit_body = new FormData();


    tabname_edit_body.append('finish_data', JSON.stringify(tabname_edit_modal_onfinish_select_info.value1));

    tabname_edit_body.append('uuid', tabname_edit_select_info.value1);


    tabname_edit_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabname_edit_body.append('time', String(tabname_edit_modal_onfinish_select_info.time));

    tabname_edit_body.append('action', 'update');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/tabinfo/update/update_tabinfo.php', {


                method: 'POST',
                body: tabname_edit_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    settabname_edit_modal_open(false)

                    setreturn_data_tabname_edit(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_tabname_select_log({message:'122',value:'',time:data_time})
                   // setButton_onclick_d('1');

                   // setref_tab_info_select_log({message: '1', value: '', time: date_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if (tabname_edit_modal_onfinish_select_log.message !== '') {

            data_async();
            settabname_edit_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [tabname_edit_modal_onfinish_select_log]);


    const [tab_child_fenlei_edit_name_modal_open, settab_child_fenlei_edit_name_modal_open] = useState(false)

    const [tab_child_fenlei_edit_name_select_info, settab_child_fenlei_edit_name_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [tab_child_fenlei_edit_name_select_log, settab_child_fenlei_edit_name_select_log] = useState({message: '', value: '', time: 0})
    const tab_child_fenlei_edit_name = (uuid: any, title: any) => {

        settab_child_fenlei_edit_name_select_log({message: 'click', value: '', time: date_time})

        settab_child_fenlei_edit_name_modal_open(true);

        settab_child_fenlei_edit_name_select_info({value1: uuid, value2: title, value3: '', time: date_time})
    }


    const settab_child_fenlei_edit_name_modal_oncancel = () => {

        settab_child_fenlei_edit_name_modal_open(false);
    }


    const [tab_child_fenlei_edit_name_modal_form] = Form.useForm();

    const tab_child_fenlei_edit_name_modal_initialValues = {}

    const [tab_child_fenlei_edit_name_modal_onfinish_select_log, settab_child_fenlei_edit_name_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [tab_child_fenlei_edit_name_modal_onfinish_select_info, settab_child_fenlei_edit_name_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const tab_child_fenlei_edit_name_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        settab_child_fenlei_edit_name_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        settab_child_fenlei_edit_name_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_tab_child_fenlei_edit_name, setreturn_data_tab_child_fenlei_edit_name] = useState({});

    const tab_child_fenlei_edit_name_body = new FormData();


    tab_child_fenlei_edit_name_body.append('finish_data', JSON.stringify(tab_child_fenlei_edit_name_modal_onfinish_select_info.value1));
    tab_child_fenlei_edit_name_body.append('uuid', tab_child_fenlei_edit_name_select_info.value1);

    tab_child_fenlei_edit_name_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tab_child_fenlei_edit_name_body.append('time', String(tab_child_fenlei_edit_name_modal_onfinish_select_info.time));

    tab_child_fenlei_edit_name_body.append('action', 'update');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/tab_child_fenlei/update/update_tab_child_fenlei_name.php', {


                method: 'POST',
                body: tab_child_fenlei_edit_name_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    settab_child_fenlei_edit_name_modal_open(false)

                    setreturn_data_tab_child_fenlei_edit_name(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setButton_onclick_d('11');
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if (tab_child_fenlei_edit_name_modal_onfinish_select_log.message !== '') {

            data_async();
            settab_child_fenlei_edit_name_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [tab_child_fenlei_edit_name_modal_onfinish_select_log]);



    const [fenlei_add_sub_modal_open, setfenlei_add_sub_modal_open] = useState(false)

    const [fenlei_add_sub_select_info, setfenlei_add_sub_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fenlei_add_sub_select_log, setfenlei_add_sub_select_log] = useState({message: '', value: '', time: 0})
    const fenlei_add_sub = (e1: any) => {

        setfenlei_add_sub_select_log({message: 'click', value: '', time: date_time})

        setfenlei_add_sub_modal_open(true);

        setfenlei_add_sub_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const setfenlei_add_sub_modal_oncancel = () => {

        setfenlei_add_sub_modal_open(false);
    }


    const [fenlei_add_sub_modal_form]=Form.useForm();

    const fenlei_add_sub_modal_initialValues={




    }

    const [fenlei_add_sub_modal_onfinish_select_log,setfenlei_add_sub_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [fenlei_add_sub_modal_onfinish_select_info,setfenlei_add_sub_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const fenlei_add_sub_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setfenlei_add_sub_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setfenlei_add_sub_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_fenlei_add_sub,setreturn_data_fenlei_add_sub]=useState({});

    const fenlei_add_sub_body = new FormData();



    fenlei_add_sub_body.append('parent_uuid', treeonselectm_info.select_value);

    fenlei_add_sub_body.append('finish_data', JSON.stringify(fenlei_add_sub_modal_onfinish_select_info.value1));

    fenlei_add_sub_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fenlei_add_sub_body.append('time', String(fenlei_add_sub_modal_onfinish_select_info.time));

    fenlei_add_sub_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/hs_info/insert/insert_hs_info.php', {


                method: 'POST',
                body: fenlei_add_sub_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setfenlei_add_sub_modal_open(false)

                    setreturn_data_fenlei_add_sub(return_data);

                    setButton_onclick_d('1');
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if(fenlei_add_sub_modal_onfinish_select_log.message!==''){

            data_async();
            setfenlei_add_sub_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [fenlei_add_sub_modal_onfinish_select_log]);



    const [hs_text_edit_modal_open, seths_text_edit_modal_open] = useState(false)

    const [hs_text_edit_select_info, seths_text_edit_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [hs_text_edit_select_log, seths_text_edit_select_log] = useState({message: '', value: '', time: 0})
    const hs_text_edit = (e1: any) => {

        seths_text_edit_select_log({message: 'click', value: '', time: date_time})

        seths_text_edit_modal_open(true);

        seths_text_edit_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const seths_text_edit_modal_oncancel = () => {

        seths_text_edit_modal_open(false);
    }


    const [hs_text_edit_modal_form]=Form.useForm();

    const hs_text_edit_modal_initialValues={




    }

    const [hs_text_edit_modal_onfinish_select_log,seths_text_edit_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [hs_text_edit_modal_onfinish_select_info,seths_text_edit_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const hs_text_edit_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        seths_text_edit_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        seths_text_edit_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_hs_text_edit,setreturn_data_hs_text_edit]=useState({});

    const hs_text_edit_body = new FormData();




    hs_text_edit_body.append('parent_uuid', treeonselectm_info_sub.title);

    hs_text_edit_body.append('finish_data', JSON.stringify(hs_text_edit_modal_onfinish_select_info.value1));

    hs_text_edit_body.append('userToken', String(Cookies.get('userToken_chattool')));

    hs_text_edit_body.append('time', String(hs_text_edit_modal_onfinish_select_info.time));

    hs_text_edit_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/hs_info/update/update_hs_info.php', {


                method: 'POST',
                body: hs_text_edit_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    seths_text_edit_modal_open(false)

                    setreturn_data_hs_text_edit(return_data);
                    setButton_onclick_d('1');
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if(hs_text_edit_modal_onfinish_select_log.message!==''){

            data_async();
            seths_text_edit_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [hs_text_edit_modal_onfinish_select_log]);





    const [hs_text_del_modal_open, seths_text_del_modal_open] = useState(false)

    const [hs_text_del_select_info, seths_text_del_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [hs_text_del_select_log, seths_text_del_select_log] = useState({message: '', value: '', time: 0})
    const hs_text_del = (e1: any) => {

        seths_text_del_select_log({message: 'click', value: '', time: date_time})

        seths_text_del_modal_open(true);

        seths_text_del_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const seths_text_del_modal_oncancel = () => {

        seths_text_del_modal_open(false);
    }


    const [hs_text_del_modal_next_button_select_log,seths_text_del_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const hs_text_del_modal_next_button = () => {

        let data_time=dayjs().unix();

        seths_text_del_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_hs_text_del,setreturn_data_hs_text_del]=useState({});

    const hs_text_del_body = new FormData();


    hs_text_del_body.append('parent_uuid', hs_text_del_select_info.value1);

    hs_text_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    hs_text_del_body.append('time', String(hs_text_del_modal_next_button_select_log.time));

    hs_text_del_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/hs_info/delete/delete_hs_info.php', {


                method: 'POST',
                body: hs_text_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    seths_text_del_modal_open(false)

                    setreturn_data_hs_text_del(return_data);
                    setButton_onclick_d('1');
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

            }

        }


        if(hs_text_del_modal_next_button_select_log.message!==''){

            data_async();
            seths_text_del_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [hs_text_del_modal_next_button_select_log]);





    const [fenlei_text_del_modal_open, setfenlei_text_del_modal_open] = useState(false)

    const [fenlei_text_del_select_info, setfenlei_text_del_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fenlei_text_del_select_log, setfenlei_text_del_select_log] = useState({message: '', value: '', time: 0})
    const fenlei_text_del = (e1: any) => {

        setfenlei_text_del_select_log({message: 'click', value: '', time: date_time})

        setfenlei_text_del_modal_open(true);

        setfenlei_text_del_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const setfenlei_text_del_modal_oncancel = () => {

        setfenlei_text_del_modal_open(false);
    }


    const [fenlei_text_del_modal_next_button_select_log,setfenlei_text_del_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const fenlei_text_del_modal_next_button = () => {

        let data_time=dayjs().unix();

        setfenlei_text_del_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_fenlei_text_del,setreturn_data_fenlei_text_del]=useState({});

    const fenlei_text_del_body = new FormData();


    fenlei_text_del_body.append('parent_uuid', treeonselectm_info.select_value);

    fenlei_text_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fenlei_text_del_body.append('time', String(fenlei_text_del_modal_next_button_select_log.time));

    fenlei_text_del_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/fl_info/delete/delete_fl_info.php', {


                method: 'POST',
                body: fenlei_text_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setfenlei_text_del_modal_open(false)

                    setreturn_data_fenlei_text_del(return_data);
                    setButton_onclick_d('1');

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

            }

        }


        if(fenlei_text_del_modal_next_button_select_log.message!==''){

            data_async();
            setfenlei_text_del_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [fenlei_text_del_modal_next_button_select_log]);


    const [table_add_info_modal_open, settable_add_info_modal_open] = useState(false)

    const [table_add_info_select_info, settable_add_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [table_add_info_select_log, settable_add_info_select_log] = useState({message: '', value: '', time: 0})
    const table_add_info = (e1: any) => {

        settable_add_info_select_log({message: 'click', value: '', time: date_time})

        settable_add_info_modal_open(true);

        settable_add_info_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const settable_add_info_modal_oncancel = () => {

        settable_add_info_modal_open(false);
    }


    const [table_add_info_modal_form]=Form.useForm();

    const table_add_info_modal_initialValues={




    }

    const [table_add_info_modal_onfinish_select_log,settable_add_info_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [table_add_info_modal_onfinish_select_info,settable_add_info_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const table_add_info_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        settable_add_info_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        settable_add_info_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_table_add_info,setreturn_data_table_add_info]=useState({});

    const table_add_info_body = new FormData();


    table_add_info_body.append('finish_data', JSON.stringify(table_add_info_modal_onfinish_select_info.value1));

    table_add_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    table_add_info_body.append('time', String(table_add_info_modal_onfinish_select_info.time));

    table_add_info_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/tabinfo/insert/insert_tabinfo.php', {


                method: 'POST',
                body: table_add_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    settable_add_info_modal_open(false)

                    setreturn_data_table_add_info(return_data);

                    setfetch_tabname_select_log({message:'dd',value:'',time:data_time})
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                   // setref_tab_info_select_log({message: 'da', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if(table_add_info_modal_onfinish_select_log.message!==''){

            data_async();
            settable_add_info_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [table_add_info_modal_onfinish_select_log]);



    const [table_add_sub_fl_info_modal_open, settable_add_sub_fl_info_modal_open] = useState(false)

    const [table_add_sub_fl_info_select_info, settable_add_sub_fl_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [table_add_sub_fl_info_select_log, settable_add_sub_fl_info_select_log] = useState({message: '', value: '', time: 0})
    const table_add_sub_fl_info = (e1: any,title:any) => {

        settable_add_sub_fl_info_select_log({message: 'click', value: '', time: date_time})

        settable_add_sub_fl_info_modal_open(true);

        settable_add_sub_fl_info_select_info({value1: e1, value2: '', value3: '', time: date_time})
    }


    const settable_add_sub_fl_info_modal_oncancel = () => {

        settable_add_sub_fl_info_modal_open(false);
    }


    const [table_add_sub_fl_info_modal_form]=Form.useForm();

    const table_add_sub_fl_info_modal_initialValues={




    }

    const [table_add_sub_fl_info_modal_onfinish_select_log,settable_add_sub_fl_info_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [table_add_sub_fl_info_modal_onfinish_select_info,settable_add_sub_fl_info_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const table_add_sub_fl_info_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        settable_add_sub_fl_info_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        settable_add_sub_fl_info_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_table_add_sub_fl_info,setreturn_data_table_add_sub_fl_info]=useState({});

    const table_add_sub_fl_info_body = new FormData();


    table_add_sub_fl_info_body.append('parent_uuid', tab_button_info.uuid);


    table_add_sub_fl_info_body.append('finish_data', JSON.stringify(table_add_sub_fl_info_modal_onfinish_select_info.value1));

    table_add_sub_fl_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    table_add_sub_fl_info_body.append('time', String(table_add_sub_fl_info_modal_onfinish_select_info.time));

    table_add_sub_fl_info_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/tab_child_fenlei/insert/insert_tab_child_fl_info.php', {


                method: 'POST',
                body: table_add_sub_fl_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    settable_add_sub_fl_info_modal_open(false)

                    setreturn_data_table_add_sub_fl_info(return_data);

                    setButton_onclick_d('11');
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/chatmagin')


                    break


            }

        }


        if(table_add_sub_fl_info_modal_onfinish_select_log.message!==''){

            data_async();
            settable_add_sub_fl_info_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [table_add_sub_fl_info_modal_onfinish_select_log]);





    return (

        <div>


            <Card>


                <div style={{display: 'flex'}}

                >


                    {/*
            <Form.Item name={'button_ui'}>
                <Flex gap="small" style={{ margin:5}}>
                    <ButtonList/>
                </Flex></Form.Item>
*/}

                    <div style={{width: 900,}}>


                        <Flex wrap="wrap" gap="small" style={{margin: 30}}>
                            {/*        {local_tab.map((button) => (
                    <Button key={web_tab_name.map(item=>(item.id))} value={web_tab_name.map(item=>(item.id))} type="primary" onClick={() => Ddclick_button(button.id,button.title)}>
                        {button.title}
                    </Button>))}*/}


                            {return_data_fetch_tabname.info.map(item => (<Button key={item.uuid} value={item.title_name}
                                                               onClick={() => Ddclick_button(item.uuid, item.title_name)}>{item.title_name} </Button>))}
                        </Flex>

                        <Form name='id' style={{margin: 30}}>


                            <Form.Item name={'tree_ui'}>

                                <DirectoryTree multiple
                                               draggable style={{height: 500}} height={500} virtual
                                               treeData={treedata_va} onSelect={Treeonselectm} blockNode={true}
                                               defaultSelectedKeys={['0-0']}

                                               defaultExpandAll onExpand={onExpand}> </DirectoryTree>


                            </Form.Item>

                        </Form>


                    </div>

                    <div style={{width: '100%'}}>

                        <label>操控</label>


                        <p></p>
                        <Card style={{}}>

<Button onClick={table_add_info}>添加table</Button>
                            <p></p>
                            选择的表
                            <p></p>
                            <label>uuid：{tab_button_info.uuid}</label>
                            <p></p>
                            <label>Tab名：{tab_button_info.tabname}</label>


                            <p></p>
                            <Button
                                onClick={() => tabname_edit(tab_button_info.uuid, tab_button_info.tabname)}>修改</Button>

                            <Button
                                onClick={() => tabname_delete(tab_button_info.uuid, tab_button_info.tabname)}>删除</Button>

                            <Button
                                onClick={() => table_add_sub_fl_info(tab_button_info.uuid, tab_button_info.tabname)}>添加fl</Button>

                        </Card>


                        {treeonselectm_info.status !== 'en' ? <></> :

                            <Card>
                                <div>
                                    <label>选择的list</label>


                                    list：{treeonselectm_info.title}

                                    <p></p>
                                    uuid：{treeonselectm_info.select_value}

                                    <p></p>
                                    <Button
                                        onClick={() => tab_child_fenlei_edit_name(treeonselectm_info.select_value, treeonselectm_info.title)}>修改</Button>

                                    <Button onClick={()=>fenlei_add_sub(treeonselectm_info.title)}>添加sub</Button>

                                    <Button onClick={()=>fenlei_text_del(treeonselectm_info.title)}>删除</Button>

                                </div>

                            </Card>
                        }


                        {treeonselectm_info_sub.status !== 'en' ? <></> :


                            <Card>

                                <div>


                                    list_sub：{treeonselectm_info_sub.select_value_sub}
                                    <p></p>
                                    list_sub_uuid：{treeonselectm_info_sub.title}
                                    <p></p>
                                    <Button onClick={()=>hs_text_edit(treeonselectm_info_sub.title)}>修改</Button>

                                    <Button onClick={()=>hs_text_del(treeonselectm_info_sub.title)}>删除</Button>
                                </div>


                            </Card>

                        }


                    </div>

                </div>


            </Card>



            <Modal open={table_add_sub_fl_info_modal_open} onCancel={settable_add_sub_fl_info_modal_oncancel} footer={null} title={'标题内容'}>




                <Form form={table_add_sub_fl_info_modal_form} initialValues={table_add_sub_fl_info_modal_initialValues} onFinish={table_add_sub_fl_info_modal_onfinish}>

                    <label>fl_txt</label>

                    <Form.Item name={'fl_name'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={settable_add_sub_fl_info_modal_oncancel}>取消</Button>

                </Form>


            </Modal>



            <Modal open={tabname_edit_modal_open} onCancel={settabname_edit_modal_oncancel} footer={null}
                   title={'重命名tabname'}>


                <Form form={tabname_edit_modal_form} initialValues={tabname_edit_modal_initialValues}
                      onFinish={tabname_edit_modal_onfinish}>

                    <label>tabname</label>

                    <Form.Item name={'tabname'} rules={[{message: '必填项', required: true}]}>

                        <Input>


                        </Input>


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft: 10}} onClick={settabname_edit_modal_oncancel}>取消</Button>

                </Form>


            </Modal>








            <Modal open={table_add_info_modal_open} onCancel={settable_add_info_modal_oncancel} footer={null} title={'标题内容'}>




                <Form form={table_add_info_modal_form} initialValues={table_add_info_modal_initialValues} onFinish={table_add_info_modal_onfinish}>

                    <label>table</label>

                    <Form.Item name={'tabname'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={settable_add_info_modal_oncancel}>取消</Button>

                </Form>


            </Modal>






            <Modal open={fenlei_text_del_modal_open} onCancel={setfenlei_text_del_modal_oncancel} footer={null} title={'标题内容'}>


                <Button onClick={fenlei_text_del_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={setfenlei_text_del_modal_oncancel}>

                    取消
                </Button>


            </Modal>



            <Modal open={hs_text_del_modal_open} onCancel={seths_text_del_modal_oncancel} footer={null} title={'标题内容'}>


                <Button onClick={hs_text_del_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={seths_text_del_modal_oncancel}>

                    取消
                </Button>


            </Modal>









            <Modal open={hs_text_edit_modal_open} onCancel={seths_text_edit_modal_oncancel} footer={null} title={'标题内容'}>




                <Form form={hs_text_edit_modal_form} initialValues={hs_text_edit_modal_initialValues} onFinish={hs_text_edit_modal_onfinish}>

                    <label>value1</label>

                    <Form.Item name={'mag1'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={seths_text_edit_modal_oncancel}>取消</Button>

                </Form>


            </Modal>





            <Modal open={fenlei_add_sub_modal_open} onCancel={setfenlei_add_sub_modal_oncancel} footer={null} title={'标题内容'}>




                <Form form={fenlei_add_sub_modal_form} initialValues={fenlei_add_sub_modal_initialValues} onFinish={fenlei_add_sub_modal_onfinish}>

                    <label>请填写内容</label>

                    <Form.Item name={'hs_text'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setfenlei_add_sub_modal_oncancel}>取消</Button>

                </Form>


            </Modal>





            <Modal open={tab_child_fenlei_edit_name_modal_open} onCancel={settab_child_fenlei_edit_name_modal_oncancel}
                   footer={null} title={'修改分类'}>


                <Form form={tab_child_fenlei_edit_name_modal_form}
                      initialValues={tab_child_fenlei_edit_name_modal_initialValues}
                      onFinish={tab_child_fenlei_edit_name_modal_onfinish}>

                    <label>分类名</label>

                    <Form.Item name={'fenlei_name'} rules={[{message: '必填项', required: true}]}>

                        <Input>


                        </Input>


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft: 10}}
                            onClick={settab_child_fenlei_edit_name_modal_oncancel}>取消</Button>

                </Form>


            </Modal>


            <Modal open={tabname_delete_modal_open} onCancel={settabname_delete_modal_oncancel} footer={null}
                   title={'标题内容'}>


                <Button onClick={tabname_delete_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft: 10}} onClick={settabname_delete_modal_oncancel}>

                    取消
                </Button>


            </Modal>


        </div>
    );


}


export default Admin_chatmagin;
